/* eslint-disable sonarjs/no-duplicated-branches */
import {
  faStar,
  faCalendarCheck,
  faCalendarTimes,
} from '@fortawesome/free-regular-svg-icons';
import {
  faWineGlassAlt,
  faSpa,
  faGlassMartiniAlt,
  faGolfBall,
  faRocket,
  faCity,
  faUtensils,
  faHotel,
  faHotTub,
  faGlassCheers,
  faTicketAlt,
  faCar,
  faRoute,
  faMoneyBillWave,
  faSwimmingPool,
  faPumpMedical,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ADDS_ICON_MAPPING = {
  access: 'Spa Access',
  centre: 'City Centre',
  checkin: 'Early check in',
  checkout: 'Late checkout',
  dinner: 'Dinner included',
  drink: 'Welcome Drink',
  fullboard: 'Full Board',
  golf: 'Golf included',
  halfboard: 'Half Board',
  hottub: 'Private Hot Tub',
  inclusive: 'All Inclusive',
  pool: 'Swimming Pool',
  prosecco: 'Prosecco',
  tickets: 'Attraction tickets',
  tour: 'Includes Tour',
  transfers: 'Transfers included',
  treatment: 'Spa treatment',
  upgrade: 'Room Upgrade',
  wine: 'Wine',
};

export const getIconMap = (item) => {
  const mappedKey = Object.keys(ADDS_ICON_MAPPING).find(
    (key) => ADDS_ICON_MAPPING[key] === item,
  );

  switch (mappedKey) {
    case 'access':
      return <FontAwesomeIcon icon={faSpa} />;
    case 'centre':
      return <FontAwesomeIcon icon={faCity} />;
    case 'checkin':
      return <FontAwesomeIcon icon={faCalendarCheck} />;
    case 'checkout':
      return <FontAwesomeIcon icon={faCalendarTimes} />;
    case 'dinner':
      return <FontAwesomeIcon icon={faUtensils} />;
    case 'drink':
      return <FontAwesomeIcon icon={faGlassMartiniAlt} />;
    case 'fullboard':
      return <FontAwesomeIcon icon={faHotel} />;
    case 'golf':
      return <FontAwesomeIcon icon={faGolfBall} />;
    case 'halfboard':
      return <FontAwesomeIcon icon={faHotel} />;
    case 'hottub':
      return <FontAwesomeIcon icon={faHotTub} />;
    case 'inclusive':
      return <FontAwesomeIcon icon={faMoneyBillWave} />;
    case 'pool':
      return <FontAwesomeIcon icon={faSwimmingPool} />;
    case 'prosecco':
      return <FontAwesomeIcon icon={faGlassCheers} />;
    case 'tickets':
      return <FontAwesomeIcon icon={faTicketAlt} />;
    case 'tour':
      return <FontAwesomeIcon icon={faRoute} />;
    case 'transfers':
      return <FontAwesomeIcon icon={faCar} />;
    case 'treatment':
      return <FontAwesomeIcon icon={faPumpMedical} />;
    case 'upgrade':
      return <FontAwesomeIcon icon={faRocket} />;
    case 'wine':
      return <FontAwesomeIcon icon={faWineGlassAlt} />;
    default:
      return <FontAwesomeIcon icon={faStar} />;
  }
};
